// Tiny wrapper around the PostHog snippet already loaded in public/index.html.
// All capture()s are no-ops if PostHog hasn't booted yet.
export const ph = (...args) => {
  if (typeof window === "undefined") return;
  if (window.posthog && typeof window.posthog.capture === "function") {
    try {
      window.posthog.capture(...args);
    } catch (_e) { /* swallow */ }
  }
};

export const phIdentify = (id, props) => {
  if (typeof window === "undefined") return;
  if (window.posthog && typeof window.posthog.identify === "function") {
    try { window.posthog.identify(id, props || {}); } catch (_e) { /* swallow */ }
  }
};
